import React, { useRef, useState } from "react";
import { Box, Card, Stack, Typography } from "@mui/material";
import { ImageStoreEntity } from "graphql/graphQlApiHooks";
import UploaderService from "services/UplodaService";
import Settings from "store/settings";
import { UploadPhotoButton } from "../SportEquipmentPhotos/PhotoGrid/UploadPhotoButton";
import Iconify from "components/Iconify";
import { PhotoThumbnail } from "../SportEquipmentPhotos/styled";

interface Props {
  barcodePhoto?: ImageStoreEntity | null;
  setBarcodePhoto: (value: ImageStoreEntity | null) => void;
  isEditable?: boolean;
}

export const BarcodePhotoUpload = (props: Props) => {
  const { barcodePhoto, setBarcodePhoto, isEditable = true } = props;
  const [uploadPercentage, setUploadPercentage] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const uploadPhotoInput = useRef<HTMLInputElement | null>(null);

  const onUploadChange: React.FormEventHandler<HTMLInputElement> = (event) => {
    setLoading(true);
    setUploadPercentage(0);
    UploaderService.uploadImage(event, {
      onUploadProgress: (progressEvent: any) => {
        const { loaded, total } = progressEvent;
        let percent = Math.floor((loaded * 100) / total);

        if (percent < 100) {
          setUploadPercentage(percent);
        }
      }
    })
      .then((res) => {
        if (res) {
          setBarcodePhoto(res);
        }
      })
      .finally(() => {
        setUploadPercentage(100);
        setLoading(false);
      });
  };

  const clearInputHandler = () => {
    if (uploadPhotoInput?.current) uploadPhotoInput.current.value = "";
  };

  const onDeleteHandler = () => {
    setBarcodePhoto(null);
    clearInputHandler();
  };

  return (
    <Stack spacing={2}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Iconify icon={"mdi:barcode"} fontSize={"1.2rem"} />
        <Typography variant={"subtitle2"} sx={{ fontWeight: 600 }}>
          Фото штрих-кода
        </Typography>
      </Box>

      <Card
        sx={{
          p: 2,
          borderRadius: 2,
          border: "1px dashed",
          borderColor: "divider",
          bgcolor: "background.paper"
        }}
      >
        <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
          {barcodePhoto && (
            <PhotoThumbnail sx={{ width: 120, height: 120, flexShrink: 0 }}>
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  borderRadius: 1,
                  overflow: "hidden",
                  border: "1px solid",
                  borderColor: "divider"
                }}
              >
                <img
                  src={
                    barcodePhoto.url.includes("http")
                      ? barcodePhoto.url
                      : Settings.server + (barcodePhoto.avatarUrl || barcodePhoto.url)
                  }
                  alt="Штрих-код"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover"
                  }}
                />
              </Box>
            </PhotoThumbnail>
          )}

          <Box sx={{ flex: 1 }}>
            <UploadPhotoButton
              buttonId="barcode-photo-upload"
              onClearInput={clearInputHandler}
              loading={loading}
              progress={uploadPercentage}
              helpText="Загрузите фото штрих-кода оборудования"
              icon="mdi:barcode-scan"
              primaryText={barcodePhoto ? "Фото загружено" : "Загрузить фото штрих-кода"}
              value={barcodePhoto as any}
              onDelete={onDeleteHandler}
              disabled={!isEditable}
              isEditable={isEditable}
            />
          </Box>
        </Box>
      </Card>

      <input
        id="button-upload-barcode-photo-upload"
        name="button-upload-barcode-photo-upload"
        style={{ display: "none" }}
        type="file"
        accept="image/*, .heic"
        onInput={onUploadChange}
        ref={uploadPhotoInput}
      />
    </Stack>
  );
};

